import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "group fixed bottom-3 right-3 bg-main-75 backdrop-blur-lg p-2 rounded border text-white text-2xs z-50"
};
const _hoisted_2 = {
  class: "hidden flex-col gap-3 group-hover:flex"
};
const _hoisted_3 = {
  class: "flex flex-col gap-2"
};
const _hoisted_4 = {
  class: "flex gap-1"
};
const _hoisted_5 = {
  class: "flex flex-col gap-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "w-full flex items-center gap-1"
  }, [_createElementVNode("div", {
    class: "h-px w-full bg-white/50"
  }), _createElementVNode("p", {
    class: "shrink-0 text-white/50"
  }, "API connection"), _createElementVNode("div", {
    class: "h-px w-full bg-white/50"
  })], -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: _normalizeClass(["py-0.5 px-2 bg-white/10 rounded-sm hover:bg-white/30 transition-[background] cursor-pointer", {
      'shadow-[0_0_0_1.5px_white] bg-white/20': this.APIconnected === 'local'
    }]),
    onClick: _cache[0] || (_cache[0] = $event => _ctx.MakeRequest.connectTo('local'))
  }, "Local", 2), _createElementVNode("div", {
    class: _normalizeClass(["py-0.5 px-2 bg-white/10 rounded-sm hover:bg-white/30 transition-[background] cursor-pointer", {
      'shadow-[0_0_0_1.5px_white] bg-white/20': this.APIconnected === 'dev'
    }]),
    onClick: _cache[1] || (_cache[1] = $event => _ctx.MakeRequest.connectTo('dev'))
  }, "Development", 2), _createElementVNode("div", {
    class: _normalizeClass(["py-0.5 px-2 bg-white/10 rounded-sm hover:bg-white/30 transition-[background] cursor-pointer", {
      'shadow-[0_0_0_1.5px_white] bg-white/20': this.APIconnected === 'prod'
    }]),
    onClick: _cache[2] || (_cache[2] = $event => _ctx.MakeRequest.connectTo('prod'))
  }, "Production", 2)])]), _createElementVNode("div", _hoisted_5, [_cache[5] || (_cache[5] = _createElementVNode("div", {
    class: "w-full flex items-center gap-1"
  }, [_createElementVNode("div", {
    class: "h-px w-full bg-white/50"
  }), _createElementVNode("p", {
    class: "shrink-0 text-white/50"
  }, "Debug Components"), _createElementVNode("div", {
    class: "h-px w-full bg-white/50"
  })], -1)), _createElementVNode("button", {
    class: "rounded bg-white/10 hover:bg-white/20 text-white py-1 px-2",
    onClick: _cache[3] || (_cache[3] = $event => this.$router.push({
      name: 'DebugComponents'
    }))
  }, "Take me to")])]), _cache[6] || (_cache[6] = _createElementVNode("i", {
    class: "icon-gear group-hover:hidden text-base"
  }, null, -1))]);
}